import React, { Fragment } from "react";
import { connect } from "react-redux";
import ShowDelivery from "../components/ShowDelivery";
import EditDelivery from "../components/EditDelivery";
import { requestDelivery, resetDelivery } from "../actions/deliveryAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

class DeliveryContainer extends React.Component {
  state = {
    activeKey: "show",
  };

  componentDidMount() {
    this.props.requestDelivery(this.props.id);
  }

  componentWillUnmount() {
    this.props.resetDelivery();
  }

  show = () => {
    this.setState({ activeKey: "show" });
  };
  edit = () => {
    this.setState({ activeKey: "edit" });
  };

  render() {
    const { loading, delivery } = this.props;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            mountOnEnter
            unmountOnExit
            id="left-tabs-example"
            activeKey={this.state.activeKey}
          >
            <div className="container-fluid">
              <Tab.Content>
                <Tab.Pane eventKey="show">
                  <ShowDelivery delivery={delivery} edit={this.edit} />
                </Tab.Pane>
                <Tab.Pane eventKey="edit">
                  <EditDelivery
                    delivery={delivery}
                    updateDelivery={this.props.requestDelivery}
                    show={this.show}
                  />
                </Tab.Pane>
              </Tab.Content>
            </div>
            {/* </Col>
            </Row> */}
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  delivery: state.requestDelivery.delivery,
  loading: state.requestDelivery.loading,
});
const mapDispatchToProps = (dispatch) => ({
  requestDelivery: (deliveryId) => dispatch(requestDelivery(deliveryId)),
  resetDelivery: () => dispatch(resetDelivery()),
});
export default connect(mapStateToProps, mapDispatchToProps)(DeliveryContainer);
